/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RegularButton, SearchInput } from 'pg-ui-library';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
// import CloseIcon from '@mui/icons-material/Close';
import useDebounce from 'src/hooks/useDebounce';
import useRolePermission from 'src/hooks/useRolePermission';
import { RolePermission } from 'src/components/sidebar';
import { Container, Header, HeaderTitle, Content, HeaderItemLeft, HeaderItemRight } from './styles';
import EnrollmentChanges from './components/enrollment-changes';
import CloseIcon from 'src/assets/close.svg';
export const benefitsForbiddenWords = ['-External', '-Internal'];
export const benefitsCategories: string[] = ['Health & Well-being', 'Income Security', 'Retirement & Lifestyle'];
const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 430,
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: '16px',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};
const buttonStyle: React.CSSProperties = {
  background: '#373A90',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  padding: '14px 36px',
  fontWeight: 600,
  fontSize: '16px',
  marginRight: '20px',
  marginTop: '24px',
  cursor: 'pointer',
  minWidth: '185px',
};
const benefitOptions = ['Users Eligible For New Hire', 'Users Not Eligible For New Hire'];
const BenefitsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const { hasRolePermission } = useRolePermission();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checked, setChecked] = useState([true, false, true]);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleToggle = (idx: number) => {
    setChecked(prev => prev.map((val, i) => (i === idx ? !val : val)));
  };
  return (
    <Container>
      <Header>
        <HeaderItemLeft>
          <HeaderTitle>{t('benefits.header.title')}</HeaderTitle>
        </HeaderItemLeft>
        <HeaderItemRight>
          <SearchInput
            value={searchTerm}
            placeholder="Search..."
            handleChange={event => {
              setSearchTerm(event.target.value);
            }}
          />
          <RegularButton onClick={() => navigate('/benefits/management', { replace: true })}>
            {t('benefits.header.management')}
          </RegularButton>
          <RegularButton onClick={() => navigate('/benefits/open-enrollment', { replace: true })}>
            {t('benefits.header.openEnrollment')}
          </RegularButton>
          {hasRolePermission(RolePermission.SUPER_ADMIN) && (
            <RegularButton onClick={() => navigate('/benefits/qle-enrollment', { replace: true })}>
              {t('benefits.header.qleEnrollment')}
            </RegularButton>
          )}
          <RegularButton onClick={() => navigate('/benefits/new-hires-list')}>New hire List</RegularButton>
        </HeaderItemRight>
      </Header>
      <Content>
        <EnrollmentChanges searchTerm={debouncedSearchTerm} />
      </Content>
    </Container>
  );
};
export default BenefitsPage;
